module.exports = __webpack_public_path__ + "static/Frogsong3-4dd4f6b3edd49c20d7126bbf924fbbf6.webp";